import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { useObjectsStatsByLocation } from '../hooks'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

interface ObjectsByLocationDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    type?: 'objects' | 'services'
}

export function ObjectsByLocationDialog({ open, onOpenChange, type = 'objects' }: ObjectsByLocationDialogProps) {
    const { t } = useTranslation()
    const { data: statsByLocation, isLoading } = useObjectsStatsByLocation()

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[600px]">
            <DialogHeader>
                <DialogTitle>
                    {type === 'objects' ? t('objects.objectsByLocation') : t('objects.servicesByLocation')}
                </DialogTitle>
                <DialogDescription>
                    {type === 'objects' ? t('objects.objectsByLocationDescription') : t('objects.servicesByLocationDescription')}
                </DialogDescription>
            </DialogHeader>

                {isLoading ? (
                    <div className="flex items-center justify-center py-8">
                        <div className="text-muted-foreground">{t('common.loading')}</div>
                    </div>
                ) : (
                    <div>
                        {type === 'objects' ? (
                            <div>
                                <h3 className="text-lg font-semibold mb-3">{t('objects.objectsByLocation')}</h3>
                                <div className="border rounded-md">
                                    <Table>
                                        <TableHeader>
                                            <TableRow>
                                                <TableHead>{t('objects.location')}</TableHead>
                                                <TableHead className="text-right">{t('objects.count')}</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {statsByLocation?.objects && statsByLocation.objects.length > 0 ? (
                                                statsByLocation.objects.map((item: any, index: number) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item.Location}</TableCell>
                                                        <TableCell className="text-right">{item.NoObjects}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={2} className="text-center text-muted-foreground">
                                                        {t('objects.noData')}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <h3 className="text-lg font-semibold mb-3">{t('objects.servicesByLocation')}</h3>
                                <div className="border rounded-md">
                                    <Table>
                                        <TableHeader>
                                            <TableRow>
                                                <TableHead>{t('objects.location')}</TableHead>
                                                <TableHead className="text-right">{t('objects.count')}</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {statsByLocation?.services && statsByLocation.services.length > 0 ? (
                                                statsByLocation.services.map((item: any, index: number) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item.Location}</TableCell>
                                                        <TableCell className="text-right">{item.NoObjects}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={2} className="text-center text-muted-foreground">
                                                        {t('objects.noData')}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    )
}
